import './App.css'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { createRoot } from 'react-dom/client'
import GameplayProvider from './contexts/gameplayContext'
import { MeasurementProvider } from './contexts/measurementContext'
import Layout from './Layout'
import * as Sentry from '@sentry/react'
import { isProductionBuild } from './utils'

if (isProductionBuild()) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: []
  })
}

// New imports for screens
import { DashboardScreen } from './components/screens/DashboardScreen'
import { SurfScreen } from './components/screens/SurfScreen'
import { QuestsScreen } from './components/screens/QuestsScreen'
import { JobsScreen } from './components/screens/JobsScreen'
import { LocationsScreen } from './components/screens/LocationsScreen'
import { StatisticsScreen } from './components/screens/StatisticsScreen'
import { UpgradesScreen } from './components/screens/UpgradesScreen'
import { SkillsScreen } from './components/screens/SkillsScreen'
import { TimelineScreen } from './components/screens/TimelineScreen'
import { SettingsScreen } from './components/screens/SettingsScreen'
import { MeasureScreen } from './components/screens/MeasureScreen'
import { AuthProvider } from './contexts/authContext'
import { Toaster } from 'sonner'
import { CompetitionScreen } from './components/screens/CompetitionScreen'

createRoot(document.getElementById('root') as HTMLElement).render(
  /*<React.StrictMode>*/
  <AuthProvider>
    <GameplayProvider>
      <MeasurementProvider>
        <BrowserRouter>
          <Layout>
            <Toaster richColors position="bottom-center" />
            <Routes>
              <Route path="/" element={<DashboardScreen />} />
              <Route path="/main" element={<DashboardScreen />} />
              <Route path="/surf" element={<SurfScreen />} />
              <Route path="/quests" element={<QuestsScreen />} />
              <Route path="/jobs" element={<JobsScreen />} />
              <Route path="/locations" element={<LocationsScreen />} />
              <Route path="/statistics" element={<StatisticsScreen />} />
              <Route path="/upgrades" element={<UpgradesScreen />} />
              <Route path="/skills" element={<SkillsScreen />} />
              <Route path="/story" element={<TimelineScreen />} />
              <Route path="/settings" element={<SettingsScreen />} />
              <Route path="/measure" element={<MeasureScreen />} />
              <Route path="/competitions" element={<CompetitionScreen />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </MeasurementProvider>
    </GameplayProvider>
  </AuthProvider>
  /*</React.StrictMode>*/
)
